import { useEffect } from 'react';
import { developmentFlag } from 'constants/common';

const useDisableRightClick = () => {
  useEffect(() => {
    if (developmentFlag) return;
    const handleRightClick = (e) => e.preventDefault();
    window.addEventListener('contextmenu', handleRightClick);
    return () => {
      window.removeEventListener('contextmenu', handleRightClick);
    };
  }, []);

  return null;
};

export default useDisableRightClick;